import React, {useContext, useEffect, useState} from "react";
import {TextFieldComponent} from "../../core/_models";
import {DateTimePicker} from "@mui/x-date-pickers";
import dayjs, {Dayjs} from "dayjs";

export function DateTimeComponent({context, config: {id, title, value, onChange}}: TextFieldComponent) {
    const [v, setValue] = useState<Dayjs | null>(dayjs(value));
    const formContext = useContext(context);

    useEffect(() => {
        formContext.set(id, v!.format('YYYY-MM-DD HH:mm:ss'))
    }, [value])

    const handleChange = (newValue: Dayjs | null) => {
        if (!newValue?.isValid()) {
            return;
        }

        setValue(newValue);
        formContext.set(id, newValue?.format('YYYY-MM-DD HH:mm:ss'))

        if (onChange !== undefined && onChange !== null) {
            formContext.submit({onChange})
        }
    };

    return (
        <DateTimePicker
            label={(typeof title === 'object' ? title.text : title)}
            value={v}
            onChange={handleChange}
            format={'DD/MM/YYYY HH:mm'}
            slotProps={{textField: {fullWidth: true, size: 'small'}}}
            ampm={false}
            views={['year', 'month', 'day']}
        />
    )
}